export class StockVariableIncome {
  positionDate: string;
  positions: StockVariableIncomePosition[]; //à vista
  optionsPositions: StockVariableIncomeOptionsPosition[];
  termPositions: StockVariableIncomeTermPosition[];
  loanPositions: StockVariableIncomeLoanPosition[];
}

export class StockVariableIncomePosition {
  assetCode: string;
  assetName: string;
  availableAmount: number;
  blockedAmount: number;
  totalAmount: number;
  price: number;
  totalCost: number;
  result: number;
  netValue: number;
}

export class StockVariableIncomeOptionsPosition {
  assetCode: string;
  stockObject: string;
  type: string;
  broker: string;
  exerciseValue: number;
  dueDate: Date;
  totalAmount: number;
  price: number;
  totalCost: number;
  result: number;
  netValue: number;
}

export class StockVariableIncomeTermPosition {
  operationCode: number;
  stockObject: string;
  type: string;
  amount: number;
  broker: string;
  actualTermPrice: number;
  originalContractValue: number;
  activeCashValue: number;
  passiveCashValue: number;
  dueDate: Date;
  businessDaysDeadline: number;
}

export class StockVariableIncomeLoanPosition {
  operationCode: number;
  assetCode: string;
  assetName: string;
  broker: string;
  loanDate: Date;
  dueDate: Date;
  loanAmount: number;
  loanValue: number;
  remuneration: number;
  isDonor: boolean;
}
